import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../../../data-structures/results/result-row.model";

interface OperatingUnitsInterface {
 'PROJECT.PLANT_SPEC.CHP'?: CHPResult;
 'PROJECT.PLANT_SPEC.UPGRADER'?: UpgraderResult;
 'PROJECT.PLANT_SPEC.BOILER'?: BoilerResult;
}
export class OperatingUnits {
  'PROJECT.PLANT_SPEC.CHP'?;
  'PROJECT.PLANT_SPEC.UPGRADER'?;
  constructor(param: OperatingUnitsInterface = {}) {
    if (param['PROJECT.PLANT_SPEC.CHP']) {
      this['PROJECT.PLANT_SPEC.CHP'] = new CHPResult(param['PROJECT.PLANT_SPEC.CHP']);
    } else{
      delete this['PROJECT.PLANT_SPEC.CHP'];
    }

    if (param['PROJECT.PLANT_SPEC.UPGRADER']) {
      this['PROJECT.PLANT_SPEC.UPGRADER'] = new UpgraderResult(param['PROJECT.PLANT_SPEC.UPGRADER']);
    } else {
      delete this['PROJECT.PLANT_SPEC.UPGRADER'];
    }

    if (param['PROJECT.PLANT_SPEC.BOILER']) {
      this['PROJECT.PLANT_SPEC.BOILER'] = new BoilerResult(param['PROJECT.PLANT_SPEC.BOILER']);
    } else {
      delete this['PROJECT.PLANT_SPEC.BOILER'];
    }
  }

  deepCopy() {
    return new OperatingUnits(cloneDeep(this));
  }
}

interface UpgraderResultInterface {
 'RESULTS.DATA.TECHNICAL.ARB'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.AAPR'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.ACIU'?: ResultRow;
}
class UpgraderResult {
  /** actual RNG/biomethane */
  'RESULTS.DATA.TECHNICAL.ARB';
  /** annual average processing rate */
  'RESULTS.DATA.TECHNICAL.AAPR';
  /** annual capacity in use */
  'RESULTS.DATA.TECHNICAL.ACIU';

  constructor(param: UpgraderResultInterface = {}) {
    if (param['RESULTS.DATA.TECHNICAL.ARB']) {
      this['RESULTS.DATA.TECHNICAL.ARB'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.ARB']);
    }
    if (param['RESULTS.DATA.TECHNICAL.AAPR']) {
      this['RESULTS.DATA.TECHNICAL.AAPR'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AAPR']);
    }
    if (param['RESULTS.DATA.TECHNICAL.ACIU']) {
      this['RESULTS.DATA.TECHNICAL.ACIU'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.ACIU']);
    }
  }

  deepCopy() {
    return new UpgraderResult(cloneDeep(this));
  }
}

interface CHPResultInterface {
 'RESULTS.DATA.TECHNICAL.AEO'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.AAEPO'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.ACIU'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.AHO'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.AAHPO'?: ResultRow;
}
class CHPResult {
  'RESULTS.DATA.TECHNICAL.AEO';
  'RESULTS.DATA.TECHNICAL.AAEPO';
  'RESULTS.DATA.TECHNICAL.ACIU';
  'RESULTS.DATA.TECHNICAL.AHO';
  'RESULTS.DATA.TECHNICAL.AAHPO';

  constructor(param: CHPResultInterface = {}) {
    if (param['RESULTS.DATA.TECHNICAL.AEO']) {
      this['RESULTS.DATA.TECHNICAL.AEO'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AEO']);
    }
    if (param['RESULTS.DATA.TECHNICAL.AAEPO']) {
      this['RESULTS.DATA.TECHNICAL.AAEPO'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AAEPO']);
    }
    if (param['RESULTS.DATA.TECHNICAL.ACIU']) {
      this['RESULTS.DATA.TECHNICAL.ACIU'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.ACIU']);
    }
    if (param['RESULTS.DATA.TECHNICAL.AHO']) {
      this['RESULTS.DATA.TECHNICAL.AHO'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AHO']);
    }
    if (param['RESULTS.DATA.TECHNICAL.AAHPO']) {
      this['RESULTS.DATA.TECHNICAL.AAHPO'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AAHPO']);
    }
  }

  deepCopy() {
    return new CHPResult(cloneDeep(this));
  }
}


interface BoilerResultInterface {
 'RESULTS.DATA.TECHNICAL.AHO'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.AAHPO'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.ACIU'?: ResultRow;
}
class BoilerResult {
  /** actual heat output */
  'RESULTS.DATA.TECHNICAL.AHO';
  /** annual average heat power output */
  'RESULTS.DATA.TECHNICAL.AAHPO';
  /** annual capacity in use */
  'RESULTS.DATA.TECHNICAL.ACIU';

  constructor(param: BoilerResultInterface = {}) {
    if (param['RESULTS.DATA.TECHNICAL.AHO']) {
      this['RESULTS.DATA.TECHNICAL.AHO'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AHO']);
    }
    if (param['RESULTS.DATA.TECHNICAL.AAHPO']) {
      this['RESULTS.DATA.TECHNICAL.AAHPO'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.AAHPO']);
    }
    if (param['RESULTS.DATA.TECHNICAL.ACIU']) {
      this['RESULTS.DATA.TECHNICAL.ACIU'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.ACIU']);
    }
  }

  deepCopy() {
    return new BoilerResult(cloneDeep(this));
  }
}